import { availableAnnotations } from '~/services/annotationTree';
import edfService from '~/services/Edf';

export const createGetChannelDataConfig = (channels) => {
    const result = {};

    for (let i in channels) {
        for (const transformation of channels[i].appliedTransformations) {
            result[i] = {
                ...result[i],
                [transformation]: channels[i].transformationsConfig[transformation] || true,
            };
        }
    }

    return result;
};

const LEVELS = [1, 5, 10, 30, 60, 120, 300, 600, 1800, 3600];
export const getAvailableZoomLevels = (recordingLength) => {
    if (recordingLength >= LEVELS[LEVELS.length - 1]) {
        return LEVELS;
    }

    const maxValidIdx = LEVELS.findIndex((size) => size >= recordingLength);

    return LEVELS.slice(0, maxValidIdx + 1);
};
export const getNextZoomLevel = (currentZoomLevel) => {
    const currentIndex = LEVELS.indexOf(currentZoomLevel);

    if (currentIndex === LEVELS.length - 1) {
        return null;
    }

    return LEVELS[currentIndex + 1];
};
export const getPreviousZoomLevel = (currentZoomLevel) => {
    const currentIndex = LEVELS.indexOf(currentZoomLevel);

    if (currentIndex === 0) {
        return null;
    }

    return LEVELS[currentIndex - 1];
};
export const visibleAnnotations = availableAnnotations.reduce((memo, current) => {
    memo[current.value] = true;

    return memo;
}, {});

export const getAllChannelDataPromises = (start, end, zoomLevel, config) => {
    const promises = [];
    const numberOfSegments = Math.trunc((end - start) / zoomLevel);
    const restOfTime = Math.floor(((end - start) / zoomLevel - numberOfSegments) * zoomLevel);

    for (let i = 1; i <= numberOfSegments; i++) {
        promises.push(
            edfService.getAllChannelData(start + zoomLevel * (i - 1), start + zoomLevel * i, config)
        );
    }

    if (restOfTime > 0) {
        promises.push(
            edfService.getAllChannelData(
                start + zoomLevel * numberOfSegments,
                start + zoomLevel * numberOfSegments + restOfTime,
                config
            )
        );
    }

    return promises;
};

export const handleZeroValues = (array, label) => {
    if (label.toLowerCase() === 'spo2' || label.toLowerCase() === 'heart rate') {
        return array.map(({ x, y }) => ({ x, y: y || 'N/A' }));
    }

    return array;
};
// TODO: Cris has to return actual min/max instead of physical, then we'll delete this logic
export const getMinMaxForProp = (prop, array) => {
    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;
    let tmp;

    for (let i = array.length - 1; i >= 0; i--) {
        tmp = array[i][prop];

        if (tmp < min) {
            min = tmp;
        }

        if (tmp > max) {
            max = tmp;
        }
    }

    return { min, max };
};
